exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".left {\n    float: left;\n    width: 50%;   \n    margin: 2px 10px;\n    display: inline;\n}\n.right {\n    text-align: right;\n    margin: 2px 10px;\n}\n.ct-mono {\n    font-family: \"Courier New\", Courier, monospace;\n    font-size: 1.1em;\n    padding: 15px;\n}\n.cal-default {\n  color:#222;\n}\n.cal-holiday {\n  color:#a59a9a;\n}\n.cal-today {\n  color: #32db64;\n  font-weight: bold;\n  font-size: 1.3em;\n}\n.col-sm-1 {\n  border-bottom: 1px solid #ddd;\n  border-top: 1px solid #ddd;\n  border-left: 1px solid #ddd;\n  border-right: 1px solid #ddd;\n  width: 97px;\n  height: 80px;\n  text-align: right;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/nivedha/Documents/github/sandbox/src/sppu-beta/src/app/home/calendarOfEvents.component.css
// module id = ../../../../../src/app/home/calendarOfEvents.component.css
// module chunks = main